const OK = "ok";
const CANCEL = "cancel";
const NO = "no";

export {
    OK,
    CANCEL,
    NO,
}